// extracted by mini-css-extract-plugin
export default {"wrapper":"OnePageTypeSwitch_wrapper__G3E7C","loaderWrapper":"OnePageTypeSwitch_loaderWrapper__0cwp7"};